module.exports = __webpack_public_path__ + "media/images/cv/screenshot_forecast_bot-7bbb2c62410c90692d0afaa9ebd40be1.png";